let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("30F0C")).then(() => parcelRequire('iOKaS'));